export const DEFAULT_CRM_TOKEN = 'i7ibzzqwvj';
export const brandLogo = `${window.assetsLocation}/images/gary_logo.png`;
export const brandShowcaseUrl = `${window.assetsLocation}/images/showcase.png`;
export const bannerUrl = `${window.assetsLocation}/images/gary_banner.png`;
export const viewReportIconUrl = `${window.assetsLocation}/images/carousel.png`;
export const twitterXIcon = `${window.assetsLocation}/images/x.svg`;
export const homeArticleIds = ['24'];
export const faqArticleIds = [
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
    '22',
    '23',
];
// Get CRM token from environment variable or use default
export const getCrmToken = () => {
    return process.env.CRM_TOKEN || DEFAULT_CRM_TOKEN;
};
// Default logout redirect URL
const DEFAULT_LOGOUT_REDIRECT_URL = 'https://garysanitarydistrictin.comcate.com/en';
// Get logout redirect URL from environment variable or use default
export const getLogoutRedirectUrl = () => {
    const redirectUrl = process.env.LOGOUT_REDIRECT_URL || DEFAULT_LOGOUT_REDIRECT_URL;
    return encodeURIComponent(redirectUrl);
};
// Generate submit request URL with dynamic CRM token
export const getSubmitRequestUrl = () => {
    const token = getCrmToken();
    const accountEnabled = process.env.ACCOUNT_ENABLED === 'true';
    if (accountEnabled) {
        const logoutRedirect = getLogoutRedirectUrl();
        return `https://agency.comcate.com/private-submission/create?crm_token=${token}&logout_redirect_url=${logoutRedirect}`;
    }
    else {
        return `https://agency.comcate.com/crm/${token}`;
    }
};
// Generate login to account URL with dynamic CRM token
export const getLoginToAccountUrl = () => {
    const token = getCrmToken();
    const logoutRedirect = getLogoutRedirectUrl();
    return `https://agency.comcate.com/private-submission/listing?crm_token=${token}&auth_enabled=true&logout_redirect_url=${logoutRedirect}`;
};
